function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9 20C11.9 18.29 13.29 16.9 15 16.9H19V15H15C12.24 15 10 17.24 10 20C10 22.76 12.24 25 15 25H19V23.1H15C13.29 23.1 11.9 21.71 11.9 20ZM16 21H24V19H16V21ZM21 15H25C27.76 15 30 17.24 30 20C30 22.76 27.76 25 25 25H21V23.1H25C26.71 23.1 28.1 21.71 28.1 20C28.1 18.29 26.71 16.9 25 16.9H21V15Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/link.f4839601.svg";
export { SvgComponent as ReactComponent };